import CartSinglePageOrderSummary from './CartSinglePageOrderSummary'

export default CartSinglePageOrderSummary
// eslint-disable-next-line import/export
export * from './CartSinglePageOrderSummary'
